import { useContext, useMemo } from "react"
import { FeatureFlagContext } from "../../../../mp-core/FeatureFlagProvider"
import {
  getFilteredDisplayedProperties,
  getFilteredHeaderColumns,
  getFilteredRequestParams,
  getHiddenFieldsByFeatureFlag
} from "../helpers"

export const useReportingTableData = () => {
  const { featureFlags, featureFlagsLoading } = useContext(FeatureFlagContext)

  const excludedFields = useMemo(() => {
    if (featureFlagsLoading) return []

    return getHiddenFieldsByFeatureFlag(featureFlags || {})
  }, [featureFlags, featureFlagsLoading])

  const reportingTableData = useMemo(() => {
    const headerColumns = getFilteredHeaderColumns(excludedFields)

    const displayedProperties = getFilteredDisplayedProperties(excludedFields)

    const requestParams = getFilteredRequestParams(excludedFields)

    return {
      headerColumns,
      displayedProperties,
      requestParams
    }
  }, [excludedFields])

  return reportingTableData
}
